import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m15.578 2.432-2-1.05C11.822.461 10.944 0 10 0S8.178.46 6.422 1.382l-.321.169 8.923 5.099 4.016-2.01c-.646-.732-1.688-1.279-3.462-2.21m4.17 3.534-3.998 2V11a.75.75 0 1 1-1.5 0V8.714l-3.5 1.75v9.44c.718-.179 1.535-.607 2.828-1.286l2-1.05c2.151-1.129 3.227-1.693 3.825-2.708.597-1.014.597-2.277.597-4.8v-.117c0-1.893 0-3.077-.252-3.979M9.25 19.904v-9.44l-8.998-4.5C0 6.866 0 8.05 0 9.941v.117c0 2.525 0 3.788.597 4.802.598 1.015 1.674 1.58 3.825 2.709l2 1.049c1.293.679 2.11 1.107 2.828 1.286M.96 4.641 10 9.161l3.411-1.705-8.886-5.078-.103.054c-1.773.93-2.816 1.477-3.462 2.21" }, null, -1)
  ]))]))
}
export default { render: render }